import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import Contact from './Contact';
import SEO from './SEO';

export const KontaktPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO page="kontakt" />
      <Header />
      <main className="flex-1 pt-20">
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default KontaktPage;
